import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CreateDraftConseilConfigInput } from '@lib/models/generated/graphql';
import { DocumentsService, FicheStorageFile } from '@lib/services/documents.service';
import { AdminConfigService } from 'src/app/services/admin-config.service';

@Component({
  selector: 'app-add-conseil-config-version-dialog',
  templateUrl: './add-conseil-config-version-dialog.component.html',
  styleUrls: ['./add-conseil-config-version-dialog.component.scss'],
})
export class AddConseilConfigVersionDialogComponent {
  isloading: boolean = false;
  files: FicheStorageFile[] = [];
  hasUpdateAvailable: boolean = false;
  currentActiveVersion: number = 0;
  useReferenceControl = new FormControl<boolean>(false, { nonNullable: true });
  useReferencelabel: string | undefined = 'Appliquer sur la nouvelle config';
  majeurVersionControl = new FormControl<boolean>(false, { nonNullable: true });
  majeurVersionLabel: string | undefined = 'Version majeure';
  conformiteDate: string;
  commentaireControl = new FormControl<string>('', { nonNullable: true });
  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: { coaId: string; activeVersion: number },
    private dialogRef: MatDialogRef<AddConseilConfigVersionDialogComponent>,
    private documentService: DocumentsService,
    private adminConfigService: AdminConfigService
  ) {
    this.conformiteDate = new Date().toISOString();
  }

  ngOnInit(): void {
    this.useReferenceControl?.disable();
    this.checkReferentielUpdate();
    this.currentActiveVersion = this.data.activeVersion;
  }

  deleteFile(fileToDelete: FicheStorageFile) {
    this.files = this.files?.filter(file => file.name !== fileToDelete.name) ?? [];
  }

  async onValid() {
    this.isloading = true;
    if (this.files && this.files.length > 0) {
      const templateName = this.files[0].name.split('.doc')[0];
      const storageFiles: FicheStorageFile[] = await this.documentService.uploadFicheStorageFiles(this.files, true);

      const input: CreateDraftConseilConfigInput = {
        coAId: this.data.coaId,
        templateName: templateName,
        useLatestReferenceConfig: this.useReferenceControl.value,
        isMajeurVersion: this.majeurVersionControl.value,
        dateObsolescenceVersionPrecedente: this.majeurVersionControl.value ? this.conformiteDate : null,
        commentaireDeVersion: this.majeurVersionControl.value ? this.commentaireControl.value : null,
      };

      const templateUrl = storageFiles[0].storageFile?.fileConnectionInfo?.sasUrl;
      if (templateUrl) {
        input.templateUrl = templateUrl;
        const result = await this.adminConfigService.createNewDraftConseilConfig(input);
        if (result?.id) {
          this.dialogRef.close(result);
        }
        this.isloading = false;
      }
    }
  }
  async checkReferentielUpdate() {
    this.isloading = true;
    this.hasUpdateAvailable = await this.adminConfigService.isUpdatedInReferentielConfig(this.data.coaId);
    if (this.hasUpdateAvailable) {
      this.useReferencelabel = `Appliquer la nouvelle config (v${this.currentActiveVersion + 1})`;
      this.useReferenceControl?.enable();
    }
    this.isloading = false;
  }
}
